import { FC } from 'react';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Button, Dialog } from '@optimus-web/core';

interface CounterFormCloseConfirmationDialogProps {
    isOpen: boolean;
    onSubmit: () => void;
    onCancel: () => void;
}

export const CounterFormCloseConfirmationDialog: FC<CounterFormCloseConfirmationDialogProps> = ({
    onSubmit,
    onCancel,
    isOpen,
}) => (
    <Dialog
        active={isOpen}
        actions={[
            {
                children: <LocalizedText textKey={TextKey.Save} />,
                onClick: onSubmit,
                variant: 'primary',
                size: 'medium',
                type: 'submit',
            },
        ]}
        footerDetail={
            <Button variant="tertiary" size="medium" onClick={onCancel} type="submit">
                <LocalizedText textKey={TextKey.Discard} />
            </Button>
        }
        title={<LocalizedText textKey={TextKey.SaveDataQuestion} />}
        size="small"
    >
        <LocalizedText textKey={TextKey.SaveDataText} />
    </Dialog>
);
